import React, { useEffect, useState } from "react";
import { Button, Container, Form, Row } from "react-bootstrap";
import { stringLiterals } from "../data";
import { useHistory, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMessage } from "../state/slices/message";
import { isAuthenticated } from "../util";
import { useLoginMutation } from "../state/services/users";

// Display the landing page for backdoor login.
// It includes a regular login (username and password) form.
function Backdoor(_props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const expiresAt = useSelector((state) => state.auth.expiresAt);

  const [login, { isLoading }] = useLoginMutation();

  useEffect(() => {
    if (!isAuthenticated(token, expiresAt)) {
      const msg =
        "This route is for <b>admin</b> only. Unless admin required you to use it for signing in, " +
        "you should return to the <a href='/'>homepage</a> and use your JHU login credentials.";

      dispatch(setMessage({ text: msg }));
    }
  }, []); // Do not add isAuthenticated or dispatch as dependency, it results in infinite render

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await login({ username, password });
      history.push("/dashboard");
    } catch (error) {
      setUsername("");
      setPassword("");
    }
  };

  if (isAuthenticated(token, expiresAt)) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <div className="homepage">
      <Container className="content text-center" fluid>
        <h1>{stringLiterals.appTitle}</h1>
        <br />
        <br />
        <Row className="d-flex justify-content-center">
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="inputUsername">
              <Form.Control
                type="text"
                placeholder="Username"
                required
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="inputPassword">
              <Form.Control
                autoComplete="off"
                type="password"
                placeholder="Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" type="submit" block>
              Sign in
            </Button>
          </Form>
        </Row>
      </Container>
    </div>
  );
}

export default Backdoor;
